module.exports = new __parcel__URL__("login_poster_2.e1b42fdf.png").toString();